import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const SearchDescriptionContentTitle = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  display: -webkit-box;
  font-family: ${Fonts['regular']};
  font-size: ${45 * Screen.widthRatio}px;
  height: ${54 * Screen.widthRatio}px;
  margin-top: ${12 * Screen.widthRatio}px;
  max-width: ${850 * Screen.widthRatio}px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;

export default SearchDescriptionContentTitle;
